/**
 * 报销审核（财务初审工作台）
 *
 * 与「待办与审批」是同一个看板，只是**锁定了业务类型为报销**——
 * 财务初审在这页只看报销单，不必在合同与发票的待办里翻找。
 *
 * 【为什么审核页面与审批中心不合并成一个菜单】审核是**岗位视角**
 * （我是财务初审，我今天要审什么），审批中心是**全员视角**（所有待办）。
 * 两者的默认筛选与心理模型不同，但底下的规则必须是同一套——
 * 所以共用组件而不是各写一份。
 */

import { BizType, PermissionCode } from '@ilc/shared';
import { ApprovalBoard } from '@/components/ApprovalBoard';

export function ExpenseReviewPage(): React.ReactElement {
  return (
    <ApprovalBoard
      lockedBizType={BizType.EXPENSE_REIMBURSE}
      title="报销审核"
      description={`审阅发票校验结果（真伪、红冲、抬头、重复报销、金额一致性）、预算占用与费用事由。所需权限：${PermissionCode.EXPENSE_REVIEW}`}
    />
  );
}

export default ExpenseReviewPage;
